import { render } from "./CustomerOrderModal.vue?vue&type=template&id=1065374b"
import script from "./CustomerOrderModal.vue?vue&type=script&lang=js"
export * from "./CustomerOrderModal.vue?vue&type=script&lang=js"

import "./CustomerOrderModal.vue?vue&type=style&index=0&id=1065374b&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\php\\POS-SYSTEM-BACKUP-STRIPE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__